import {
    Dialog,
    DialogTitle,
    IconButton,
    Slide,
    Typography
} from "@mui/material";
import { IconClose } from "assets/icons";
import { TooltipCC } from "components/common";
import React from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setCloseCurrentDialog } from "store/dialogSlice";
import theme from "theme";
import { setCloseDialogCC } from "utils/helpers";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogBaseCC = ({ children, title, id, customClose, autoOpen = false }) => {
    const { open, idDialog } = useSelector((state) => state.dialog);
    const {t} = useTranslation()
    const dispatch = useDispatch()

    const handleCloseDialog = () => {
        if(customClose){
            customClose()
        }
        setCloseDialogCC()
        dispatch(setCloseCurrentDialog())
    }

    return (
        <Dialog
            open={autoOpen || (open && id === idDialog)}
            onClose={handleCloseDialog}
            aria-labelledby="responsive-dialog-title"
            TransitionComponent={Transition}
            maxWidth={"sm"}
            fullWidth
        >
            <DialogTitle>
                <Typography
                    sx={{ fontSize: "1.5rem", fontWeight: 600, marginRight: '16px'}}
                >
                    {title || 'Dialog title'}
                </Typography>
                <TooltipCC title={t('dialog.close')}>
                    <IconButton sx={{ position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), '& svg': { transform: 'scale(1.25)' } }} aria-label="close" onClick={handleCloseDialog}>
                        <IconClose />
                    </IconButton>
                </TooltipCC>
            </DialogTitle>
            {children}
        </Dialog>
    );
};

export default DialogBaseCC